"use client";
import { jsxs as f, jsx as a } from "react/jsx-runtime";
import { cva as m } from "class-variance-authority";
import { useId as b } from "react";
import { SelectRoot as p, SelectTrigger as k, SelectValue as x, SelectIcon as v } from "../../atoms/Select/Select.mjs";
import { cn as i } from "../../../utils/utils.mjs";
const g = m(
  "flex items-center border font-semibold text-base [&_[data-slot=select-value]_span]:font-semibold dark:bg-neutral-dark-100 dark:text-neutral-dark-1000 dark:border-transparent dark:hover:not-disabled:border-neutral-dark-600 dark:disabled:bg-neutral-dark-900 dark:disabled:border-neutral-dark-500 dark:disabled:text-neutral-dark-600",
  {
    variants: {
      variant: {
        default: "h-14 min-w-32 w-fit rounded-full p-4 gap-4",
        "icon-only": "h-10 w-11 rounded-3xl px-2 py-4 gap-1"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), N = ({
  className: n,
  children: o,
  variant: r = "default",
  icon: t,
  placeholder: d,
  selectTriggerProps: s,
  selectValueProps: c,
  ...u
}) => {
  const e = r === "icon-only", l = b();
  return /* @__PURE__ */ f(p, { ...u, children: [
    /* @__PURE__ */ a(
      k,
      {
        "aria-labelledby": e ? void 0 : l,
        "aria-label": e ? d : void 0,
        iconPrefix: t ? /* @__PURE__ */ a("span", { className: "[&_path]:fill-white", children: t }) : void 0,
        iconSuffix: /* @__PURE__ */ a(v, { className: i(e ? "size-2" : "size-4") }),
        className: i(g({ variant: r }), n),
        ...s,
        children: !e && /* @__PURE__ */ a(x, { id: l, placeholder: d, ...c })
      }
    ),
    o
  ] });
};
export {
  N as MediaSelect
};
